import '~/core/application'
import ModalController from '~/controllers/modal_controller'
import PurchaseOnlineOripaModal from '~/components/organisms/oripa/lotteries/PurchaseOnlineOripaModal.vue'
import onEnter from '~/core/onEnter'
import { findController } from '~/lib/stimulus'

function openModal(unit: number): void {
  const modal = document.querySelector('#purchase-online-oripa-modal')

  if (!modal || !(modal instanceof HTMLElement)) return

  const propsStr = modal.dataset.props || ''
  const propsData = JSON.parse(propsStr)
  const controller = findController<ModalController>('modal')
  if (!controller) return

  controller.showWithVue(PurchaseOnlineOripaModal, {
    propsData: {
      title: propsData.title,
      lottery_id: propsData.lottery_id,
      amount: unit,
      points: propsData.points,
      price: propsData.price,
      remaining: propsData.remaining,
      credit_card_brand: propsData.credit_card_brand,
      credit_card_no: propsData.credit_card_no,
      credit_card_expire: propsData.credit_card_expire,
      credit_card_registered: propsData.credit_card_registered,
    },
  })
}

function onClickPurchaseButton(e: Event): void {
  if (e.target instanceof HTMLElement) {
    if (e.target.dataset.unit !== undefined) {
      openModal(Number(e.target.dataset.unit))
    }
  }
}

onEnter(() => {
  document.querySelectorAll('.oripa-footer__btn').forEach((purchaseButton) => {
    if (!purchaseButton || !(purchaseButton instanceof HTMLElement)) return
    purchaseButton.addEventListener('click', onClickPurchaseButton)
  })
})
